/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useRef, useState } from 'react';
import { StyleSheet, View } from 'react-native';

import { postJSON } from '../support/Fetch';
import { useShowMessage } from '../core-ui';

import {
  Form,
  SubmitButton,
  Text,
  Button,
  TextInput,
  TextInputType,
} from './uiold';
import { themeColors } from './uiold/Constants';
import LoadingIndicator from './uiold/LoadingIndicator';

type Props = {
  onBackToLogin: () => void;
};

function ForgotPasswordForm(props: Props) {
  const inputRef = useRef<TextInputType>(null);
  const showMessage = useShowMessage();

  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState('');

  const renderLoadingIndicator = () => {
    if (isLoading) {
      return <LoadingIndicator />;
    }
  };

  const forgotPasswordSubmit = () => {
    if (!username) {
      return;
    }
    setIsLoading(true);
    submitForm(username);
  };

  const submitForm = (username: string) => {
    let reqData = {
      username,
    };
    // TODO: Change this endpoint.
    postJSON(`/api/users/password/reset`, reqData, (error, data) => {
      if (error) {
        showMessage('error', error.message);
        setTimeout(() => {
          inputRef.current?.focus();
        }, 500);
      } else {
        if (data.success) {
          showMessage(
            'success',
            t('A password reset link has been sent to your email'),
          );
          setUsername('');
        } else {
          showMessage('error', data.errorMessage);
          setTimeout(() => {
            let instance = inputRef.current;
            instance && instance.focus();
          }, 500);
        }
      }
      setIsLoading(false);
    });
  };

  let { onBackToLogin } = props;
  return (
    <View style={styles.root}>
      <Form style={styles.mainView} onSubmit={forgotPasswordSubmit}>
        <Text style={styles.resetPasswordTitle}>{t('Reset Password')}</Text>
        {renderLoadingIndicator()}
        <TextInput
          style={styles.formControl}
          autoFocus
          ref={inputRef}
          placeholder={t('Username')}
          value={username}
          onChangeText={(value) => setUsername(value)}
        />
        <SubmitButton
          title={t('Submit')}
          style={styles.submitButton}
          hoverStyle={styles.active}
          isDisabled={!username}
          textStyle={styles.submitButtonText}
        />
      </Form>
      <Button
        style={styles.backToLoginButton}
        titleType="label"
        textStyle={styles.backToLoginText}
        textHoverStyle={{ textDecorationLine: 'underline' }}
        title={t('Back to Login')}
        onPress={onBackToLogin}
      />
    </View>
  );
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  mainView: {
    paddingHorizontal: 30,
    paddingTop: 10,
    flex: 1,
    alignItems: 'center',
  },
  active: {
    backgroundColor: themeColors.greenButtonHovered,
    borderColor: themeColors.buttonHoveredBorder,
  },
  formControl: {
    backgroundColor: themeColors.textInputBackground,
    height: 43,
    color: themeColors.textInputText,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: themeColors.textInputBorder,
  },
  resetPasswordTitle: {
    flex: 1,
    textAlign: 'center',
    color: themeColors.formTitle,
    fontWeight: '300',
    fontSize: 28,
    marginBottom: 25,
    marginTop: 20,
  },
  backToLoginButton: {
    marginHorizontal: 0,
    backgroundColor: themeColors.buttonGrey,
    width: '100%',
    borderBottomLeftRadius: 7,
    borderBottomRightRadius: 7,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    height: 58,
    borderWidth: 0,
  },
  backToLoginText: {
    fontWeight: '600',
    color: themeColors.greyButtonText,
    paddingVertical: 20,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  submitButton: {
    marginHorizontal: 0,
    paddingVertical: 10,
    paddingHorizontal: 30,
    marginTop: 15,
    marginBottom: 25,
    backgroundColor: themeColors.formButtonBackground,
    borderColor: themeColors.formButtonBorder,
    borderRadius: 3,
    width: '100%',
  },
  submitButtonText: {
    textAlign: 'center',
    fontWeight: '600',
    textTransform: 'uppercase',
    color: 'white',
    marginHorizontal: 0,
  },
});

export default ForgotPasswordForm;
